export default {
    "AF": {
        "name": "Afganisztán"
    },
    "AL": {
        "name": "Albánia"
    },
    "DZ": {
        "name": "Algéria"
    },
    "US": {
        "name": "Amerikai Egyesült Államok"
    },
    "AD": {
        "name": "Andorra"
    },
    "AO": {
        "name": "Angola"
    },
    "AG": {
        "name": "Antigua és Barbuda"
    },
    "AR": {
        "name": "Argentína"
    },
    "AU": {
        "name": "Ausztrália"
    },
    "AT": {
        "name": "Ausztria"
    },
    "AZ": {
        "name": "Azerbajdzsán"
    },
    "BS": {
        "name": "Bahama-szigetek"
    },
    "BH": {
        "name": "Bahrein"
    },
    "BD": {
        "name": "Banglades"
    },
    "BB": {
        "name": "Barbados"
    },
    "BE": {
        "name": "Belgium"
    },
    "BZ": {
        "name": "Belize"
    },
    "BJ": {
        "name": "Benin"
    },
    "BT": {
        "name": "Bhután"
    },
    "GW": {
        "name": "Bissau-Guinea"
    },
    "BO": {
        "name": "Bolívia"
    },
    "BA": {
        "name": "Bosznia-Hercegovina"
    },
    "BW": {
        "name": "Botswana"
    },
    "BR": {
        "name": "Brazília"
    },
    "BN": {
        "name": "Brunei"
    },
    "BG": {
        "name": "Bulgária"
    },
    "BF": {
        "name": "Burkina Faso"
    },
    "BI": {
        "name": "Burundi"
    },
    "CL": {
        "name": "Chile"
    },
    "CY": {
        "name": "Ciprus"
    },
    "KM": {
        "name": "Comore-szigetek"
    },
    "CR": {
        "name": "Costa Rica"
    },
    "TD": {
        "name": "Csád"
    },
    "CZ": {
        "name": "Csehország"
    },
    "DK": {
        "name": "Dánia"
    },
    "ZA": {
        "name": "Dél-afrikai Köztársaság"
    },
    "SS": {
        "name": "Dél-Szudán"
    },
    "KR": {
        "name": "Dél-Korea (Koreai Köztársaság)"
    },
    "DM": {
        "name": "Dominikai Közösség"
    },
    "DO": {
        "name": "Dominikai Köztársaság"
    },
    "DJ": {
        "name": "Dzsibuti"
    },
    "EC": {
        "name": "Ecuador"
    },
    "GQ": {
        "name": "Egyenlítői-Guinea"
    },
    "AE": {
        "name": "Egyesült Arab Emírségek"
    },
    "GB": {
        "name": "Egyesült Királyság"
    },
    "EG": {
        "name": "Egyiptom"
    },
    "CI": {
        "name": "Elefántcsontpart"
    },
    "SV": {
        "name": "Salvador"
    },
    "ER": {
        "name": "Eritrea"
    },
    "KP": {
        "name": "Észak-Korea (Koreai NDK)"
    },
    "EE": {
        "name": "Észtország"
    },
    "ET": {
        "name": "Etiópia"
    },
    "BY": {
        "name": "Fehéroroszország"
    },
    "FJ": {
        "name": "Fidzsi"
    },
    "FI": {
        "name": "Finnország"
    },
    "FR": {
        "name": "Franciaország"
    },
    "PH": {
        "name": "Fülöp-szigetek"
    },
    "GA": {
        "name": "Gabon"
    },
    "GM": {
        "name": "Gambia"
    },
    "GH": {
        "name": "Ghána"
    },
    "GR": {
        "name": "Görögország"
    },
    "GD": {
        "name": "Grenada"
    },
    "GE": {
        "name": "Grúzia"
    },
    "GT": {
        "name": "Guatemala"
    },
    "GN": {
        "name": "Guinea"
    },
    "GY": {
        "name": "Guyana"
    },
    "HT": {
        "name": "Haiti"
    },
    "NL": {
        "name": "Hollandia"
    },
    "HN": {
        "name": "Honduras"
    },
    "HR": {
        "name": "Horvátország"
    },
    "IN": {
        "name": "India"
    },
    "ID": {
        "name": "Indonézia"
    },
    "IQ": {
        "name": "Irak"
    },
    "IR": {
        "name": "Irán"
    },
    "IE": {
        "name": "Írország"
    },
    "IS": {
        "name": "Izland"
    },
    "IL": {
        "name": "Izrael"
    },
    "JM": {
        "name": "Jamaica"
    },
    "JP": {
        "name": "Japán"
    },
    "YE": {
        "name": "Jemen"
    },
    "JO": {
        "name": "Jordánia"
    },
    "KH": {
        "name": "Kambodzsa"
    },
    "CM": {
        "name": "Kamerun"
    },
    "CA": {
        "name": "Kanada"
    },
    "QA": {
        "name": "Katar"
    },
    "KZ": {
        "name": "Kazahsztán"
    },
    "TL": {
        "name": "Kelet-Timor"
    },
    "KE": {
        "name": "Kenya"
    },
    "CN": {
        "name": "Kína"
    },
    "KG": {
        "name": "Kirgizisztán"
    },
    "KI": {
        "name": "Kiribati"
    },
    "CO": {
        "name": "Kolumbia"
    },
    "CD": {
        "name": "Kongói Demokratikus Köztársaság (Zaire)"
    },
    "CG": {
        "name": "Kongói Köztársaság (Kongó)"
    },
    "CF": {
        "name": "Közép-Afrika"
    },
    "CU": {
        "name": "Kuba"
    },
    "KW": {
        "name": "Kuvait"
    },
    "LA": {
        "name": "Laosz"
    },
    "PL": {
        "name": "Lengyelország"
    },
    "LS": {
        "name": "Lesotho"
    },
    "LV": {
        "name": "Lettország"
    },
    "LB": {
        "name": "Libanon"
    },
    "LR": {
        "name": "Libéria"
    },
    "LY": {
        "name": "Líbia"
    },
    "LI": {
        "name": "Liechtenstein"
    },
    "LT": {
        "name": "Litvánia"
    },
    "LU": {
        "name": "Luxemburg"
    },
    "MK": {
        "name": "Észak-Macedónia"
    },
    "MG": {
        "name": "Madagaszkár"
    },
    "HU": {
        "name": "Magyarország"
    },
    "MY": {
        "name": "Malajzia"
    },
    "MW": {
        "name": "Malawi"
    },
    "MV": {
        "name": "Maldív-szigetek"
    },
    "ML": {
        "name": "Mali"
    },
    "MT": {
        "name": "Málta"
    },
    "MA": {
        "name": "Marokkó"
    },
    "MH": {
        "name": "Marshall-szigetek"
    },
    "MR": {
        "name": "Mauritánia"
    },
    "MU": {
        "name": "Mauritius"
    },
    "MX": {
        "name": "Mexikó"
    },
    "MM": {
        "name": "Mianmar"
    },
    "FM": {
        "name": "Mikronézia"
    },
    "MD": {
        "name": "Moldova"
    },
    "MC": {
        "name": "Monaco"
    },
    "MN": {
        "name": "Mongólia"
    },
    "ME": {
        "name": "Montenegró"
    },
    "MZ": {
        "name": "Mozambik"
    },
    "NA": {
        "name": "Namíbia"
    },
    "NR": {
        "name": "Nauru"
    },
    "DE": {
        "name": "Németország"
    },
    "NP": {
        "name": "Nepál"
    },
    "NI": {
        "name": "Nicaragua"
    },
    "NE": {
        "name": "Niger"
    },
    "NG": {
        "name": "Nigéria"
    },
    "NO": {
        "name": "Norvégia"
    },
    "IT": {
        "name": "Olaszország"
    },
    "OM": {
        "name": "Omán"
    },
    "RU": {
        "name": "Oroszország"
    },
    "AM": {
        "name": "Örményország"
    },
    "PK": {
        "name": "Pakisztán"
    },
    "PW": {
        "name": "Palau"
    },
    "PA": {
        "name": "Panama"
    },
    "PG": {
        "name": "Pápua Új-Guinea"
    },
    "PY": {
        "name": "Paraguay"
    },
    "PE": {
        "name": "Peru"
    },
    "PT": {
        "name": "Portugália"
    },
    "RO": {
        "name": "Románia"
    },
    "RW": {
        "name": "Ruanda"
    },
    "KN": {
        "name": "Saint Kitts és Nevis"
    },
    "LC": {
        "name": "Saint Lucia"
    },
    "VC": {
        "name": "Saint Vincent és a Grenadine-szigetek"
    },
    "SB": {
        "name": "Salamon-szigetek"
    },
    "SM": {
        "name": "San Marino"
    },
    "ST": {
        "name": "São Tomé és Príncipe"
    },
    "SC": {
        "name": "Seychelle-szigetek"
    },
    "SL": {
        "name": "Sierra Leone"
    },
    "ES": {
        "name": "Spanyolország"
    },
    "LK": {
        "name": "Srí Lanka"
    },
    "SR": {
        "name": "Suriname"
    },
    "CH": {
        "name": "Svájc"
    },
    "SE": {
        "name": "Svédország"
    },
    "WS": {
        "name": "Szamoa"
    },
    "SA": {
        "name": "Szaúd-Arábia"
    },
    "SN": {
        "name": "Szenegál"
    },
    "RS": {
        "name": "Szerbia"
    },
    "SG": {
        "name": "Szingapúr"
    },
    "SY": {
        "name": "Szíria"
    },
    "SK": {
        "name": "Szlovákia"
    },
    "SI": {
        "name": "Szlovénia"
    },
    "SO": {
        "name": "Szomália"
    },
    "SD": {
        "name": "Szudán"
    },
    "SZ": {
        "name": "Szváziföld"
    },
    "TJ": {
        "name": "Tádzsikisztán"
    },
    "TZ": {
        "name": "Tanzánia"
    },
    "TH": {
        "name": "Thaiföld"
    },
    "TG": {
        "name": "Togo"
    },
    "TO": {
        "name": "Tonga"
    },
    "TR": {
        "name": "Törökország"
    },
    "TT": {
        "name": "Trinidad és Tobago"
    },
    "TN": {
        "name": "Tunézia"
    },
    "TV": {
        "name": "Tuvalu"
    },
    "TM": {
        "name": "Türkmenisztán"
    },
    "UG": {
        "name": "Uganda"
    },
    "NZ": {
        "name": "Új-Zéland"
    },
    "UA": {
        "name": "Ukrajna"
    },
    "UY": {
        "name": "Uruguay"
    },
    "UZ": {
        "name": "Üzbegisztán"
    },
    "VU": {
        "name": "Vanuatu"
    },
    "VE": {
        "name": "Venezuela"
    },
    "VN": {
        "name": "Vietnám"
    },
    "ZM": {
        "name": "Zambia"
    },
    "ZW": {
        "name": "Zimbabwe"
    },
    "CV": {
        "name": "Zöld-foki Köztársaság"
    }
}